import { configureStore } from '@reduxjs/toolkit'
import { commonSlice } from './common.slice'
import { kioskAuthSlice } from './kioskAuthSlice'
import { publicStore } from './public/public'
import { secureStore } from './secure/secure'
import { promptsStore } from './secure/prompts'
import { commonStore } from './public/common'
import { accountStore } from './secure/api.account'
import { adminStore } from './secure/api.admin'
import { flightStore } from './secure/api.flights'
import { kioskStore } from './secure/api.kiosk'
import { integerationStore } from './secure/api.integrations'
import { rtkQueryErrorLogger } from './rtk-query-error-logger'

import { breadcrumbMiddleware } from './breadcrumb-middleware';

export const store = configureStore({
  reducer: {
    [commonSlice.name]: commonSlice.reducer,
    [kioskAuthSlice.name]: kioskAuthSlice.reducer,
    [publicStore.reducerPath]: publicStore.reducer,
    [secureStore.reducerPath]: secureStore.reducer,
    [promptsStore.reducerPath]: promptsStore.reducer,
    [commonStore.reducerPath]: commonStore.reducer,
    [accountStore.reducerPath]: accountStore.reducer,
    [adminStore.reducerPath]: adminStore.reducer,
    [flightStore.reducerPath]: flightStore.reducer,
    [kioskStore.reducerPath]: kioskStore.reducer,
    [integerationStore.reducerPath]: integerationStore.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    breadcrumbMiddleware, 
    rtkQueryErrorLogger, 
    publicStore.middleware, 
    secureStore.middleware, 
    promptsStore.middleware, 
    commonStore.middleware, 
    accountStore.middleware, 
    adminStore.middleware, 
    flightStore.middleware, 
    kioskStore.middleware, 
    integerationStore.middleware 
  ),
})


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
